export default class TimeoutError extends Error {
	name = 'TimeoutError';
}
